import _classCallCheck from "/home/runner/work/help/help/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/help/help/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/runner/work/help/help/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/help/help/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/help/help/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Dropdown/dropdown';
import { DropdownContext } from './dropdownConstants';
import { css } from '@patternfly/react-styles';
import { KEY_CODES } from '../../helpers/constants';
var buttonVariantStyles = {
  default: '',
  primary: styles.modifiers.primary,
  secondary: styles.modifiers.secondary
};
export var Toggle = /*#__PURE__*/function (_React$Component) {
  _inherits(Toggle, _React$Component);

  var _super = _createSuper(Toggle);

  function Toggle() {
    var _this;

    _classCallCheck(this, Toggle);

    _this = _super.apply(this, arguments);
    _this.buttonRef = React.createRef();

    _this.componentDidMount = function () {
      document.addEventListener('click', _this.onDocClick);
      document.addEventListener('touchstart', _this.onDocClick);
      document.addEventListener('keydown', _this.onEscPress);
    };

    _this.componentWillUnmount = function () {
      document.removeEventListener('click', _this.onDocClick);
      document.removeEventListener('touchstart', _this.onDocClick);
      document.removeEventListener('keydown', _this.onEscPress);
    };

    _this.onDocClick = function (event) {
      var _this$props = _this.props,
          isOpen = _this$props.isOpen,
          parentRef = _this$props.parentRef,
          onToggle = _this$props.onToggle,
          getMenuRef = _this$props.getMenuRef;
      var menuRef = getMenuRef && getMenuRef();
      var clickedOnToggle = parentRef && parentRef.current && parentRef.current.contains(event.target);
      var clickedWithinMenu = menuRef && menuRef.contains && menuRef.contains(event.target);

      if (isOpen && !(clickedOnToggle || clickedWithinMenu)) {
        onToggle(false, event);
      }
    };

    _this.onEscPress = function (event) {
      var _this$props2 = _this.props,
          parentRef = _this$props2.parentRef,
          getMenuRef = _this$props2.getMenuRef;
      var keyCode = event.keyCode || event.which;
      var menuRef = getMenuRef && getMenuRef();
      var escFromToggle = parentRef && parentRef.current && parentRef.current.contains(event.target);
      var escFromWithinMenu = menuRef && menuRef.contains && menuRef.contains(event.target);

      if (_this.props.isOpen && (keyCode === KEY_CODES.ESCAPE_KEY || event.key === 'Tab') && (escFromToggle || escFromWithinMenu)) {
        _this.props.onToggle(false, event);

        _this.buttonRef.current.focus();
      }
    };

    _this.onKeyDown = function (event) {
      if (event.key === 'Tab' && !_this.props.isOpen) {
        return;
      }

      if ((event.key === 'Tab' || event.key === 'Enter' || event.key === ' ') && _this.props.isOpen) {
        if (!_this.props.bubbleEvent) {
          event.stopPropagation();
        }

        event.preventDefault();

        _this.props.onToggle(!_this.props.isOpen, event);
      } else if ((event.key === 'Enter' || event.key === ' ') && !_this.props.isOpen) {
        if (!_this.props.bubbleEvent) {
          event.stopPropagation();
        }

        event.preventDefault();

        _this.props.onToggle(!_this.props.isOpen, event);

        _this.props.onEnter();
      }
    };

    return _this;
  }

  _createClass(Toggle, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _a = this.props,
          className = _a.className,
          children = _a.children,
          isOpen = _a.isOpen,
          isDisabled = _a.isDisabled,
          isPlain = _a.isPlain,
          isText = _a.isText,
          isPrimary = _a.isPrimary,
          isSplitButton = _a.isSplitButton,
          toggleVariant = _a.toggleVariant,
          onToggle = _a.onToggle,
          ariaHasPopup = _a['aria-haspopup'],
          isActive = _a.isActive,
          bubbleEvent = _a.bubbleEvent,
          onEnter = _a.onEnter,
          parentRef = _a.parentRef,
          getMenuRef = _a.getMenuRef,
          id = _a.id,
          type = _a.type,
          props = __rest(_a, ["className", "children", "isOpen", "isDisabled", "isPlain", "isText", "isPrimary", "isSplitButton", "toggleVariant", "onToggle", 'aria-haspopup', "isActive", "bubbleEvent", "onEnter", "parentRef", "getMenuRef", "id", "type"]);

      return React.createElement(DropdownContext.Consumer, null, function (_ref) {
        var toggleClass = _ref.toggleClass;
        return React.createElement("button", Object.assign({}, props, {
          id: id,
          ref: _this2.buttonRef,
          className: css(isSplitButton ? styles.dropdownToggleButton : toggleClass || styles.dropdownToggle, isActive && styles.modifiers.active, isPlain && styles.modifiers.plain, isText && styles.modifiers.text, isPrimary && styles.modifiers.primary, buttonVariantStyles[toggleVariant], className),
          type: type || 'button',
          onClick: function onClick(event) {
            return onToggle(!isOpen, event);
          },
          "aria-expanded": isOpen,
          "aria-haspopup": ariaHasPopup,
          onKeyDown: function onKeyDown(event) {
            return _this2.onKeyDown(event);
          },
          disabled: isDisabled
        }), children);
      });
    }
  }]);

  return Toggle;
}(React.Component);
Toggle.displayName = 'Toggle';
Toggle.defaultProps = {
  className: '',
  isOpen: false,
  isActive: false,
  isDisabled: false,
  isPlain: false,
  isText: false,
  isPrimary: false,
  isSplitButton: false,
  onToggle: function onToggle() {},
  onEnter: function onEnter() {},
  bubbleEvent: false
};